import { Account, IRiskTolerance } from '../sp-types/accountTypes';

export const getRiskTolerance = (formulaId: string, account: Account): IRiskTolerance | undefined =>
  account.formulasToAccount.find((m) => m.formulaId === formulaId)?.RiskTolerance;

export const createEmptyRiskTolerance = (
  riskDanger: number = 0,
  riskWarn: number = 0,
): IRiskTolerance => ({
  dangerMinus: -riskDanger,
  warnMinus: -riskWarn,
  warnPlus: riskWarn,
  dangerPlus: riskDanger,
});

export function getSortedRouteIdsByMaterialId(account: Account, formulaId: string): string[] | undefined {
  return account.formulasToAccount
    .find((material) => material.formulaId === formulaId)
    ?.RoutePriority?.sort((a, b) => a.order - b.order)
    .map((priority) => priority.routeId);
}
